import { Format, List } from '../../..'
import { defineMessages, useIntl } from 'react-intl'
import { AdditionalInfo } from '../../AdditionalInfo'
import useViewport from '../../../../hooks/useViewport'
import { Loan } from '../../../../quartermaster/src/types'
import { Text, Icon, Button, ButtonGroup } from '@homebotapp/hb-react-component-catalog'

import styles from './ConfirmLoanDetailsInfo.module.scss'
import { HOMEOWNER_DIGEST_AVM_MODULE_CONFIRM_LOAN_SECTION } from '../../../../constants/tracking/trackingEventLocations/homeownerDigestTrackingEventLocation'

export const MSG = defineMessages({
  doubleCheckNumbers: {
    id: 'Homeowner.interest.doubleCheckNumbers',
    defaultMessage: 'Quick check, we found these loans from public records:'
  },
  doubleCheckDesc: {
    id: 'Homeowner.interest.doubleCheckLoanDescription',
    defaultMessage: '{termYears} year loan at {rate} for {amount} from {date}'
  },
  looksRight: {
    id: 'General.looksRight',
    defaultMessage: 'That looks right'
  },
  changeNumbers: {
    id: 'General.changeTheseNumbers',
    defaultMessage: 'Change these numbers'
  }
})

interface ConfirmLoanDetailsInfoProps {
  loans: Loan[]
  handleConfirmLoans: () => void
  handleUpdateLoanClick: () => void
  shouldCheckNumbers: boolean
}

export const ConfirmLoanDetailsInfo = ({
  loans,
  handleConfirmLoans,
  handleUpdateLoanClick,
  shouldCheckNumbers
}: ConfirmLoanDetailsInfoProps) => {
  const intl = useIntl()
  const { isMediumOrAbove } = useViewport()

  return (
    <AdditionalInfo visible={shouldCheckNumbers} headingText={intl.formatMessage(MSG.doubleCheckNumbers)}>
      <List.Bulleted className={styles.loanList}>
        {loans.map(loan => (
          <Text size='sm' key={loan.id} textAlign='left' marginTop='2'>
            {intl.formatMessage(MSG.doubleCheckDesc, {
              termYears: loan.termYears || loan.termYearsEstimated,
              rate: <Text as='span'>{loan.rate || loan.rateEstimated}%</Text>,
              amount: (
                <Text as='span'>
                  <Format.Currency value={loan.amount} />
                </Text>
              ),
              date: <Format.Date value={loan.date} format='MMMM YYYY' />
            })}
          </Text>
        ))}
      </List.Bulleted>
      <ButtonGroup orientation={isMediumOrAbove ? 'horizontal' : 'vertical'}>
        <Button
          data-qa='confirm'
          onClick={handleConfirmLoans}
          leftIcon={<Icon name='check' />}
          tracking={{
            guid: 'rJWcaDzUCEfy5VUE89xnyq',
            ui_context: HOMEOWNER_DIGEST_AVM_MODULE_CONFIRM_LOAN_SECTION,
            descriptor: MSG.looksRight.defaultMessage
          }}
        >
          {intl.formatMessage(MSG.looksRight)}
        </Button>
        <Button
          data-qa='change'
          onClick={handleUpdateLoanClick}
          leftIcon={<Icon name='wrench' />}
          tracking={{
            guid: '2yRYKJnjjXfY4HgZyFti9k',
            ui_context: HOMEOWNER_DIGEST_AVM_MODULE_CONFIRM_LOAN_SECTION,
            descriptor: MSG.changeNumbers.defaultMessage
          }}
        >
          {intl.formatMessage(MSG.changeNumbers)}
        </Button>
      </ButtonGroup>
    </AdditionalInfo>
  )
}
